import React, { useState, useEffect } from 'react';

import './styles.css';

import trainingsServices from '../../../../../services/academy/trainingsServices';

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import { FaFutbol } from 'react-icons/fa';

function PopupNewTraining(props) {
    const dateNow = new Date();
    const [date, setDate] = useState(`${dateNow.getFullYear()}-${String(dateNow.getMonth() + 1).padStart(2, '0')}-${String(dateNow.getDate()).padStart(2, '0')}`);
    const [frequency, setFrequency] = useState('');
    const [startTime, setStartTime] = useState('00:00');
    const [endTime, setEndTime] = useState('00:00');

    useEffect(() => {
        const dateNow = new Date();
        setStartTime(`${String(dateNow.getHours()).padStart(2, '0')}:00`);
        setEndTime(`${String((dateNow.getHours() + 1) % 24).padStart(2, '0')}:00`);
    }, [props.visibility]);

    async function createTraining() {
        console.log(date);
        console.log(frequency);
        console.log(startTime);
        console.log(endTime);
        if(date && startTime && endTime) {
            const response = await trainingsServices.postTraining(props.classId, date, startTime, endTime, frequency ? frequency[0] : 'N');
            if(response.status === 201) {
                props.setVisibility(false);
                props.onCreate();
            } else
                alert("Erro ao ler XXXX, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios*");
    }

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaFutbol />}
            tittle='Novo treino'
        >
            <form>
                <div className='line'>
                    <Input
                        label="Data*"
                        // placeholder="Selecione uma data"
                        type='date'
                        id='class-new-training-date'
                        onChange={(event) => setDate(event.target.value)}
                        value={date}
                    />
                    <Input
                        label='Frequência'
                        placeholder="Selecione a frequência"
                        type='select'
                        noFilterOptions
                        options={["Não se repete", 'Semanal', 'Quinzenal']}
                        id='class-new-training-frequency'
                        onChange={(event) => setFrequency(event.target.value)}
                        value={frequency}
                    />
                </div>
                <div className='line'>
                    <Input
                        label='Início*'
                        type='time'
                        id='class-new-training-start-time'
                        onChange={(event) => setStartTime(event.target.value)}
                        value={startTime}
                    />
                    <Input
                        label='Fim*'
                        type='time'
                        id='class-new-training-end-time'
                        onChange={(event) => setEndTime(event.target.value)}
                        value={endTime}
                    />
                </div>
                <button type='button' className='blue' onClick={createTraining}>Agendar</button>
            </form>
        </Popup>
    )
}

export default PopupNewTraining;